import {
  SET_LABELING_HISTORY,
  GET_LABELING_HISTORY,
  GET_LABELING_HISTORY_SUCCESS,
  GET_LABELING_HISTORY_ERROR,
  SET_LABELING_HISTORY_DISPLAY,
} from "./constants";

export const setLabelingHistory = (payload) => ({
  type: SET_LABELING_HISTORY,
  payload,
});

export const getLabelingHistory = (payload) => ({
  type: GET_LABELING_HISTORY,
  payload,
});

export const getLabelingHistorySuccess = (payload) => ({
  type: GET_LABELING_HISTORY_SUCCESS,
  payload,
});

export const getLabelingHistoryError = (payload) => ({
  type: GET_LABELING_HISTORY_ERROR,
  payload,
});

export const setLabelingHistoryDisplay = (payload) => ({
  type: SET_LABELING_HISTORY_DISPLAY,
  payload,
});
